import { useState } from "react";
import { toast } from "react-hot-toast";
import { trpc } from "../../../dashboard/utils/trpc";

export function SimpleContactModal(props: { onClose: () => void }) {
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [businessName, setBusinessName] = useState("");
	const [wantCustomFeatures, setWantCustomFeatures] = useState(false);
	const [customFeatures, setCustomFeatures] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);

	const mutation = trpc.email.contact.useMutation();

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setIsSubmitting(true);

		try {
			await mutation.mutateAsync({
				name,
				email,
				businessName,
				wantCustomFeatures,
				customFeatures: wantCustomFeatures ? customFeatures : undefined,
			});

			toast.success("Message sent successfully!");
			props.onClose();
		} catch (error) {
			console.error("Failed to send email:", error);
			toast.error("Failed to send message. Please try again later.");
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div
			className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
			onClick={props.onClose}
		>
			<div
				className="w-full max-w-lg rounded-lg bg-slate-800 border border-slate-700 p-6 shadow-xl"
				onClick={(e) => e.stopPropagation()}
			>
				<div className="mb-4 flex items-center justify-between">
					<h2 className="text-2xl font-bold text-white">
						Contact Us
					</h2>
					<button
						onClick={props.onClose}
						className="text-slate-400 hover:text-white"
					>
						<i className="fas fa-times"></i>
					</button>
				</div>
				<form onSubmit={handleSubmit} className="flex flex-col gap-4">
					<div>
						<label className="block text-sm font-medium text-slate-200 mb-2">
							Your Name
						</label>
						<input
							type="text"
							value={name}
							onChange={(e) => setName(e.target.value)}
							required
							disabled={isSubmitting}
							className="w-full rounded-md border border-slate-600 bg-slate-700 px-3 py-2 text-white placeholder-slate-400 focus:border-sesh-primary focus:outline-none focus:ring-1 focus:ring-sesh-primary"
						/>
					</div>
					
					<div>
						<label className="block text-sm font-medium text-slate-200 mb-2">
							Email Address
						</label>
						<input
							type="email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							required
							disabled={isSubmitting}
							className="w-full rounded-md border border-slate-600 bg-slate-700 px-3 py-2 text-white placeholder-slate-400 focus:border-sesh-primary focus:outline-none focus:ring-1 focus:ring-sesh-primary"
						/>
					</div>

					<div>
						<label className="block text-sm font-medium text-slate-200 mb-2">
							Company or Community Name
						</label>
						<input
							type="text"
							value={businessName}
							onChange={(e) => setBusinessName(e.target.value)}
							required
							disabled={isSubmitting}
							className="w-full rounded-md border border-slate-600 bg-slate-700 px-3 py-2 text-white placeholder-slate-400 focus:border-sesh-primary focus:outline-none focus:ring-1 focus:ring-sesh-primary"
						/>
					</div>
					
					<div className="flex items-start gap-2">
						<input
							type="checkbox"
							id="customFeatures"
							checked={wantCustomFeatures}
							onChange={(e) => setWantCustomFeatures(e.target.checked)}
							disabled={isSubmitting}
							className="mt-1 h-4 w-4 rounded border-slate-600 bg-slate-700 text-sesh-primary focus:ring-sesh-primary"
						/>
						<label
							htmlFor="customFeatures"
							className="text-sm text-slate-200"
						>
							Do you want custom features for the bot in addition to having a custom avatar and name?
						</label>
					</div>
					
					{wantCustomFeatures && (
						<div>
							<label className="block text-sm font-medium text-slate-200 mb-2">
								Describe the custom features you'd like
							</label>
							<textarea
								value={customFeatures}
								onChange={(e) => setCustomFeatures(e.target.value)}
								placeholder="Tell us about the specific features you need..."
								rows={4}
								disabled={isSubmitting}
								className="w-full rounded-md border border-slate-600 bg-slate-700 px-3 py-2 text-white placeholder-slate-400 focus:border-sesh-primary focus:outline-none focus:ring-1 focus:ring-sesh-primary"
							/>
						</div>
					)}
					
					<button
						type="submit"
						disabled={isSubmitting}
						className="mt-4 w-full rounded-md bg-sesh-primary px-4 py-2 font-semibold text-slate-900 transition-colors hover:bg-sesh-primary/90 disabled:opacity-50 disabled:text-slate-900"
					>
						{isSubmitting ? "Sending..." : "Submit"}
					</button>
				</form>
			</div>
		</div>
	);
}